module.exports = __webpack_public_path__ + "img/8b26030.jpg";